// persistConfig.ts

import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'stepper', 'investment', 'completedProjects'], // Add 'project' here
  // whitelist: ['auth', 'stepper'],  // Add 'project' here
};

export default persistConfig;
